import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
class RestrictedAccessPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle(app.session && app.session.user ? 'Accès non autorisé' : 'Accès réservé aux membres');
  }
  logIn() {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
  }
  signUp() {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'));
  }
  view() {
    const connected = !!(app.session && app.session.user);
    return m("div", {
      className: "ValRestrictedAccessPage"
    }, m("div", {
      className: "ValRestrictedAccessHero"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", null, connected ? 'Accès non autorisé' : 'Accès réservé aux membres'), m("p", null, connected ? 'Votre compte ne dispose pas des droits nécessaires pour accéder à cette rubrique.' : 'Cette rubrique du forum est réservée aux membres autorisés.')))), m("div", {
      className: "container"
    }, m("div", {
      className: "ValRestrictedAccessCard"
    }, m("div", {
      className: "ValRestrictedAccessIcon",
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-lock"
    })), connected ? m('[', null, m("h2", null, "Acc\xE8s insuffisant"), m("p", null, "Vous \xEAtes bien connect\xE9, mais votre compte ne poss\xE8de pas actuellement les droits n\xE9cessaires pour consulter ce forum."), m("div", {
      className: "ValRestrictedAccessActions"
    }, m("a", {
      className: "Button Button--primary",
      href: "/contactadmin"
    }, "Contacter l\u2019administration"))) : m('[', null, m("h2", null, "Rejoignez Vintage Audio Laser"), m("p", null, "Connectez-vous \xE0 votre compte ou inscrivez-vous gratuitement pour acc\xE9der aux rubriques r\xE9serv\xE9es aux membres."), m("div", {
      className: "ValRestrictedAccessActions"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: this.logIn.bind(this)
    }, "Se connecter"), m(Button, {
      className: "Button",
      onclick: this.signUp.bind(this)
    }, "S\u2019inscrire"))), m("a", {
      className: "ValRestrictedAccessBack",
      href: "/"
    }, "Retour \xE0 l\u2019accueil du forum"))));
  }
}
app.initializers.add('val-ui-restricted-access', () => {
  app.routes.valRestrictedAccess = {
    path: '/acces-reserve',
    component: RestrictedAccessPage
  };
});